import * as moment from 'moment';

import { Model } from './model';
import { Ship } from './ship';

import { FilterHandler } from '../shared/filter-handler';

export class Effort extends Model {
  id: number;
  year: string;
  ship: Ship = new Ship();
  ship_id: number;
  amount_deep: number;
  amount_shore: number;
  consumed_deep: number;
  consumed_shore: number;
  pending_deep: number;
  pending_shore: number;
  consumed_ar: string;
  creation_date: moment.Moment;
  last_update_date: moment.Moment;

  isEditingShore = false;
  isEditingDeep = false;

  constructor(values: Object = {}) {
    super(values);
  }

  public apiMap(values: Object = {}) {
    const effort = new Effort(values);

    if (values['ship']) {
      effort.ship = new Ship(values['ship']);
    }

    return effort;
  }
}

export class EffortFilter extends FilterHandler {
  ships: Ship[] = [];
  year: string;

  constructor(values: Object = {}) {
    super();

    this.ships = [];
    this.year = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/effort.ts